/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { Spin, Card, Form, Input } from 'antd';
import SideNav from '../company-settings/side-nav/component';
import { getPreferenceFromAccount, RootState, Toaster } from '@share/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { handlePreferences, IAccountSettingState } from '@store/slices';
import {
  BACKGROUND_COLOR_FIELD_KEY,
  BANNER_PRIMARY_PHOTO_FIELD_KEY,
  BANNER_PRIMARY_PHOTO_URL_FIELD_KEY,
  BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY,
  BANNER_SEARCH_RESULT_PHOTO_URL_FIELD_KEY,
  BANNER_SECONDARY_PHOTO_FIELD_KEY,
  BANNER_SECONDARY_PHOTO_URL_FIELD_KEY,
  BUTTONS_COLOR_FIELD_KEY,
  FAVICON_FIELD_KEY,
  FOOTER_BACKGROUND_COLOR_FIELD_KEY,
  FOOTER_FONTS_COLOR_FIELD_KEY,
  FOOTER_PHOTO_FIELD_KEY,
  HEADER_BACKGROUND_COLOR_FIELD_KEY,
  HEADER_FONTS_COLOR_FIELD_KEY,
  IAccount,
  IAccountPreference,
  LOGO_FIELD_KEY,
  PAGE_TITLE_FIELD_KEY,
  SEARCH_ICONS_COLOR_FIELD_KEY,
} from '@share/common-types';
import { ILoginState } from '@share/store/slices';

import './style.scss';
import { SketchPicker } from 'react-color';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccountBanner } from '@components';
import { Col, Row } from 'react-bootstrap';
import { BlueButton } from '@share/components';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IMapStateToProps {
  loginStore: ILoginState;
  accountSettingStore: IAccountSettingState;
}

interface IMapDispatchToProps {
  handlePreferences: (
    account: IAccount,
    preferences: IAccountPreference[],
    formData: FormData,
  ) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {}

interface FieldData {
  name: string[];
  value?: any;
}

function CompanyBrandingComponent(props: IProps) {

  const [fields, setFields] = useState<FieldData[]>([]);
  const [fileBanner1, setFileBanner1] = useState();
  const [primaryBanner, setPrimaryBanner] = useState<any>({});
  const [fileBanner2, setFileBanner2] = useState();
  const [urlBanner1, setUrlBanner1] = useState('');
  const [urlBanner2, setUrlBanner2] = useState('');
  const [searchResultBannerFile, setSearchResultBannerFile] = useState('');
  const [fileLogo, setFileLogo] = useState();
  const [fileFooterPhoto, setFileFooterPhoto] = useState();
  const [fileFavicon, setFileFavicon] = useState();
  const [logo, setLogo] = useState<any>({});
  const [footerPhoto, setfooterPhoto] = useState<any>({});
  const [favicon, setFavicon] = useState<any>({});
  const [buttonsColor, setButtonsColor] = useState('');
  const [iconColor, setIconColor] = useState('');
  const [pageTitle, setPageTitle] = useState('');
  const [headerIconColor, setHeaderIconColor] = useState('');   
  const [footerIconColor, setFooterIconColor] = useState('');
  const [headerFontColor, setHeaderFontColor] = useState('');
  const [footerFontColor, setFooterFontColor] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('');
  const [displayPicker, setDisplayPicker] = useState(false);
  const [displayIconPicker, setDisplayIconPicker] = useState(false);
  const [displayHeaderIconPicker, setDisplayHeaderIconPicker] = useState(false);
  const [displayFooterIconPicker, setDisplayFooterIconPicker] = useState(false);
  const [displayHeaderFontPicker, setDisplayHeaderFontPicker] = useState(false);
  const [displayFooterFontPicker, setDisplayFooterFontPicker] = useState(false);
  const [displayBackgroundPicker, setDisplayBackgroundPicker] = useState(false);

  const { loading } = props.accountSettingStore;
  const { account } = props.loginStore;

  useEffect(() => {
    setFields([
      {
        name: [LOGO_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, LOGO_FIELD_KEY),
      },
      {
        name: [BANNER_PRIMARY_PHOTO_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, BANNER_PRIMARY_PHOTO_FIELD_KEY),
      },
      {
        name: [FOOTER_PHOTO_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, FOOTER_PHOTO_FIELD_KEY),
      },
      {
        name: [FAVICON_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, FAVICON_FIELD_KEY),
      },
      {
        name: [BUTTONS_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, BUTTONS_COLOR_FIELD_KEY, ''),
      },
      {
        name: [SEARCH_ICONS_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, SEARCH_ICONS_COLOR_FIELD_KEY, ''),
      },
      {
        name: [HEADER_BACKGROUND_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(
          props.loginStore.account,
          HEADER_BACKGROUND_COLOR_FIELD_KEY,
          '',
        ),
      },
      {
        name: [FOOTER_BACKGROUND_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(
          props.loginStore.account,
          FOOTER_BACKGROUND_COLOR_FIELD_KEY,
          '',
        ),
      },
      {
        name: [HEADER_FONTS_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, HEADER_FONTS_COLOR_FIELD_KEY, ''),
      },
      {
        name: [FOOTER_FONTS_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, FOOTER_FONTS_COLOR_FIELD_KEY, ''),
      },
      {
        name: [BACKGROUND_COLOR_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, BACKGROUND_COLOR_FIELD_KEY, ''),
      },
      {
        name: [PAGE_TITLE_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, PAGE_TITLE_FIELD_KEY),
      },
    ]);
    setLogo(JSON.parse(getPreferenceFromAccount(props.loginStore.account, LOGO_FIELD_KEY)));
    setPrimaryBanner(JSON.parse(getPreferenceFromAccount(props.loginStore.account, BANNER_PRIMARY_PHOTO_FIELD_KEY)));
    setfooterPhoto(JSON.parse(getPreferenceFromAccount(props.loginStore.account, FOOTER_PHOTO_FIELD_KEY)));
    setFavicon(JSON.parse(getPreferenceFromAccount(props.loginStore.account, FAVICON_FIELD_KEY)));
    setButtonsColor(
      getPreferenceFromAccount(props.loginStore.account, BUTTONS_COLOR_FIELD_KEY, ''),
    );
    setIconColor(
      getPreferenceFromAccount(props.loginStore.account, SEARCH_ICONS_COLOR_FIELD_KEY, ''),
    );
    setHeaderIconColor(
      getPreferenceFromAccount(props.loginStore.account, HEADER_BACKGROUND_COLOR_FIELD_KEY, ''),
    );
    setFooterIconColor(
      getPreferenceFromAccount(props.loginStore.account, FOOTER_BACKGROUND_COLOR_FIELD_KEY, ''),
    );
    setHeaderFontColor(
      getPreferenceFromAccount(props.loginStore.account, HEADER_FONTS_COLOR_FIELD_KEY, ''),
    );
    setFooterFontColor(
      getPreferenceFromAccount(props.loginStore.account, FOOTER_FONTS_COLOR_FIELD_KEY, ''),
    );
    setBackgroundColor(
      getPreferenceFromAccount(props.loginStore.account, BACKGROUND_COLOR_FIELD_KEY, ''),
    );
    setPageTitle(getPreferenceFromAccount(props.loginStore.account, PAGE_TITLE_FIELD_KEY, ''));
  }, []);

  const onFinish = async () => {
    const preferences: IAccountPreference[] = [
      ...fields.map((item: FieldData) => ({
        key: item.name[0],
        value: item.value,
      })),
      { key: FOOTER_FONTS_COLOR_FIELD_KEY, value: footerFontColor },
      { key: BUTTONS_COLOR_FIELD_KEY, value: buttonsColor },
      { key: SEARCH_ICONS_COLOR_FIELD_KEY, value: iconColor },
      { key: HEADER_BACKGROUND_COLOR_FIELD_KEY, value: headerIconColor },
      { key: FOOTER_BACKGROUND_COLOR_FIELD_KEY, value: footerIconColor },
      { key: HEADER_FONTS_COLOR_FIELD_KEY, value: headerFontColor },
      { key: BACKGROUND_COLOR_FIELD_KEY, value: backgroundColor },
      { key: PAGE_TITLE_FIELD_KEY, value: pageTitle },
    ];
  
    const formData = new FormData();
  
    const fileMappings = [
      { file: fileLogo, key: LOGO_FIELD_KEY },
      { file: fileFooterPhoto, key: FOOTER_PHOTO_FIELD_KEY },
      { file: fileFavicon, key: FAVICON_FIELD_KEY },
      { file: fileBanner1, key: BANNER_PRIMARY_PHOTO_FIELD_KEY },
      { file: fileBanner2, key: BANNER_SECONDARY_PHOTO_FIELD_KEY },
      { file: searchResultBannerFile, key: BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY },
    ];
  
    fileMappings.forEach(({ file, key }) => {
      if (file) {
        formData.append(key, file);
        if (key !== LOGO_FIELD_KEY && key !== FAVICON_FIELD_KEY && key !== FOOTER_PHOTO_FIELD_KEY ) {
          preferences.push({ key, value: '' });
        }
      }
    });
  
    if (urlBanner1) {
      preferences.push({ key: BANNER_PRIMARY_PHOTO_URL_FIELD_KEY, value: urlBanner1 });
    }
  
    if (urlBanner2) {
      preferences.push({ key: BANNER_SECONDARY_PHOTO_URL_FIELD_KEY, value: urlBanner2 });
    }
    if (!primaryBanner) {
      preferences.push({ key: BANNER_PRIMARY_PHOTO_FIELD_KEY, value: null });
    }
  
    if (searchResultBannerFile) {
      preferences.push({
        key: BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY,
        value: JSON.stringify({
          key: `${account?.name}/${(searchResultBannerFile as any)?.name}`,
          value: null,
        }),
      });
    }
    props.handlePreferences(account as any, preferences, formData);
  };
  
  const handleUpload = (info: any, type: string) => {
    const file = info.target.files[0] as File;
    if (!file) return;

    const isSvg = file.type === 'image/svg+xml';
    const reader = new FileReader();
    reader.onload = (e) => {
      if (type === 'logo') {
        if (isSvg) {
          Toaster.info('SVG files are not accepted.');
          return;
        }
        setFileLogo(info.target.files[0]);
        setLogo({ Key: file.name, Value: e?.target?.result as string });
      }      
      if (type === 'footerPhoto') {
        setFileFooterPhoto(info.target.files[0]);
        setfooterPhoto({ Key: file.name, Value: e?.target?.result as string });
      }      
      if (type == 'favicon') {
        setFileFavicon(info.target.files[0]);
        setFavicon({ Key: file.name, Value: e?.target?.result as string });
      }
      if (type == 'bannerPrimaryPhotoFile') {
        setPrimaryBanner({ Key: file.name, Value: e?.target?.result as string });
        setFileBanner1(info.target.files[0]);
      }
      if (type == 'bannerSecondaryPhotoFile') {
        setFileBanner2(info.target.files[0]);
      }
      if (type == 'bannerSearchResultPhotoFile') {
        setSearchResultBannerFile(info.target.files[0]);
      }
    };
    reader.readAsDataURL(file);
  };

  const renderColorPicker = (
    display: boolean,
    color: string,
    handleColorChange: any,
    handleClosePicker: any,
  ) => {
    if (display) {
      return (
        <div className="color-picker">
          <div className="cover" onClick={handleClosePicker} />
          {color ? (
            <SketchPicker color={color} disableAlpha onChange={handleColorChange} />
          ) : (
            <SketchPicker onChange={handleColorChange} disableAlpha />
          )}
        </div>
      );
    }
    return null;
  };

  const handleColorClick = (value: any, key: string) => {
    if (key == BUTTONS_COLOR_FIELD_KEY) {
      setButtonsColor(value.hex);
    }
    if (key == SEARCH_ICONS_COLOR_FIELD_KEY) {
      setIconColor(value.hex);
    }
    if (key == HEADER_BACKGROUND_COLOR_FIELD_KEY) {
      setHeaderIconColor(value.hex);
    }
    if (key == FOOTER_BACKGROUND_COLOR_FIELD_KEY) {
      setFooterIconColor(value.hex);
    }
    if (key == HEADER_FONTS_COLOR_FIELD_KEY) {
      setHeaderFontColor(value.hex);
    }
    if (key == FOOTER_FONTS_COLOR_FIELD_KEY) {
      setFooterFontColor(value.hex);
    }
    if (key == BACKGROUND_COLOR_FIELD_KEY) {
      setBackgroundColor(value.hex);
    }
    let updatedList = fields.map((item) => {
      if (item.name[0] == key) {
        return { ...item, value: value.hex };
      }
      return item;
    });

    setFields(updatedList);
  };
  const handleTitleRemove = (key: string) => {
    if (key == PAGE_TITLE_FIELD_KEY) {
      setPageTitle('');
      setFields([
        {
          name: [PAGE_TITLE_FIELD_KEY],
          value: '',
        },
      ]);
    }
  }
  const handleColorRemove = (key: string) => {
    if (key == BUTTONS_COLOR_FIELD_KEY) {
      setButtonsColor('');
      setFields([
        {
          name: [BUTTONS_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == SEARCH_ICONS_COLOR_FIELD_KEY) {
      setIconColor('');
      setFields([
        {
          name: [SEARCH_ICONS_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == HEADER_BACKGROUND_COLOR_FIELD_KEY) {
      setHeaderIconColor('');
      setFields([
        {
          name: [HEADER_BACKGROUND_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == FOOTER_BACKGROUND_COLOR_FIELD_KEY) {
      setFooterIconColor('');
      setFields([
        {
          name: [FOOTER_BACKGROUND_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == HEADER_FONTS_COLOR_FIELD_KEY) {
      setHeaderFontColor('');
      setFields([
        {
          name: [HEADER_FONTS_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == FOOTER_FONTS_COLOR_FIELD_KEY) {
      setFooterFontColor('');
      setFields([
        {
          name: [FOOTER_FONTS_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == BACKGROUND_COLOR_FIELD_KEY) {
      setBackgroundColor('');
      setFields([
        {
          name: [BACKGROUND_COLOR_FIELD_KEY],
          value: '',
        },
      ]);
    }
  };
  const handleLogoRemove = (key: string) => {
    if (key == FOOTER_PHOTO_FIELD_KEY) {
      setfooterPhoto('');
      setFields([
        {
          name: [FOOTER_PHOTO_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == LOGO_FIELD_KEY) {
      setLogo('');
      setFields([
        {
          name: [LOGO_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == FAVICON_FIELD_KEY) {
      setFavicon('');
      setFields([
        {
          name: [FAVICON_FIELD_KEY],
          value: '',
        },
      ]);
    }
    if (key == BANNER_PRIMARY_PHOTO_FIELD_KEY) {
      setPrimaryBanner('');
      setFields([
        {
          name: [BANNER_PRIMARY_PHOTO_FIELD_KEY],
          value: '',
        },
      ]);
    }
  };

  const handleUpdateAccountFiles = (url: string, fileEvent: any, fileNameState: string) => {
    if (fileEvent) {
      handleUpload(fileEvent, fileNameState);
    } else if (url) {
      if (fileNameState === 'bannerPrimaryPhotoFile') {
        setUrlBanner1(url);
      }
      if (fileNameState === 'bannerSecondaryPhotoFile') {
        setUrlBanner2(url);
      }
    }
  };
  const intl = useIntl();
  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm border mb-5">
              <div className="card-header border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-palette fa-fw mx-2"></i><FormattedMessage id="branding" />
                </h4>
              </div>
              <div className="card-body border-bottom p-0">
                <Spin spinning={loading}>
                  <Form
                    className="branding-form"
                    fields={fields}
                    layout="vertical"
                    onFieldsChange={(_, allFields) => {
                      setFields(allFields);
                    }}
                    onFinish={onFinish}
                  >
                    <Card bordered={false} className="border-bottom">
                      <Row className="gy-3">
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={LOGO_FIELD_KEY}
                            label={intl.formatMessage({ id: 'logo' })}
                            rules={[{ required: !logo?.Value, message: `Logo is required` }]}
                          >
                            <label
                              className="mb-0 save-account__fields-row"
                              htmlFor="uploadLogo"
                            >
                              <div className="save-account__input border-0 p-0" style={{ minHeight: '100%' }}>
                            <span className='btn btn-light btn-branding mb-0'>
                                {logo ? intl.formatMessage({ id: 'edit' }) : intl.formatMessage({ id: 'upload' })}
                                </span>
                                </div>
                            </label>
                            <Input
                              id="uploadLogo"
                              onChange={(file) => handleUpload(file, 'logo')}
                              type="file"
                              className="form-control d-none"
                            />
                            {/* {logo && (
                                <div className="brandingColor_right">
                                  <FontAwesomeIcon
                                    icon={faTimesCircle}
                                    className="save-branding__clear-property"
                                    onClick={() => handleLogoRemove(LOGO_FIELD_KEY)}
                                  />
                                </div>
                              )} */}
                          </Form.Item>
                        </Col>

                        <Col xl={6} md={6}>
                          <Form.Item
                            name={FAVICON_FIELD_KEY}
                            label={intl.formatMessage({ id: 'favicon' })}
                            rules={[{ required: !favicon?.Value, message: `favicon is required` }]}
                          >
                            <label className="mb-0 save-account__fields-row" htmlFor="uploadFavicon">
                            <div className="save-account__input border-0 p-0" style={{ minHeight: '100%' }}>
                               <span className='btn btn-light btn-branding mb-0'>
                                {favicon ? intl.formatMessage({ id: 'edit' }) : intl.formatMessage({ id: 'upload' })}
                                </span>
                              </div>
                            </label>
                            <Input
                              id="uploadFavicon"
                              onChange={(file) => handleUpload(file, 'favicon')}
                              type="file"
                              className="form-control d-none"
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={FOOTER_PHOTO_FIELD_KEY}
                            label="footerPhoto"
                            rules={[{ required: !footerPhoto?.Value, message: `Footer photo is required` }]}
                          >
                            <label
                              className="mb-0 save-account__fields-row"
                              htmlFor="uploadFooterPhoto"
                            >
                              <div className="save-account__input border-0 p-0" style={{ minHeight: '100%' }}>
                                <span className='btn btn-light btn-branding mb-0'>
                                  {footerPhoto ? intl.formatMessage({ id: 'edit' }) : intl.formatMessage({ id: 'upload' })}
                                </span> 
                              </div>
                            </label>
                            <Input
                              id="uploadFooterPhoto"
                              onChange={(file) => handleUpload(file, 'footerPhoto')}
                              type="file"
                              className="form-control d-none"
                            />
                            {/* {footerPhoto && (
                                <div className="brandingColor_right">
                                  <FontAwesomeIcon
                                    icon={faTimesCircle}
                                    className="save-branding__clear-property"
                                    onClick={() => handleLogoRemove(FOOTER_PHOTO_FIELD_KEY)}
                                  />
                                </div>
                              )} */}
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <AccountBanner
                            account={account}
                            fieldUrl={BANNER_PRIMARY_PHOTO_URL_FIELD_KEY}
                            fieldImage={BANNER_PRIMARY_PHOTO_FIELD_KEY}
                            title={'account.details.home_banner_primary'}
                            onClick={(url: string, file: any) =>
                              handleUpdateAccountFiles(url, file, 'bannerPrimaryPhotoFile')
                            }
                            handleLogoRemove={handleLogoRemove}
                          />
                        </Col>
                        <Col xl={6} md={6}>
                          <AccountBanner
                            account={account}
                            fieldUrl={BANNER_SECONDARY_PHOTO_URL_FIELD_KEY}
                            fieldImage={BANNER_SECONDARY_PHOTO_FIELD_KEY}
                            title={'account.details.home_banner_secondary'}
                            onClick={(url: string, file: any) =>
                              handleUpdateAccountFiles(url, file, 'bannerSecondaryPhotoFile')
                            }
                            handleLogoRemove={handleLogoRemove}
                          />
                        </Col>
                        <Col xl={6} md={6}>
                          <AccountBanner
                            account={account}
                            fieldUrl={BANNER_SEARCH_RESULT_PHOTO_URL_FIELD_KEY}
                            fieldImage={BANNER_SEARCH_RESULT_PHOTO_FIELD_KEY}
                            title={'account.details.search_result_banner'}
                            onClick={(url: string, file: any) =>
                              handleUpdateAccountFiles(url, file, 'bannerSearchResultPhotoFile')
                            }
                            handleLogoRemove={handleLogoRemove}
                          />
                        </Col>
                        <Col xl={6} md={6} className="brandingHeading">
                          <Form.Item name={PAGE_TITLE_FIELD_KEY} label={intl.formatMessage({ id: 'page.title' })}>
                            <Input
                              type="text"
                              className="form-control form-control-lg"
                              placeholder="Enter Page Title"
                              onChange={(e) => setPageTitle(e.target.value)}
                            />
                          </Form.Item>
                          {pageTitle &&  (
                            <div className="brandingHeading_close">
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                className="save-branding__clear-property"
                                onClick={() => handleTitleRemove(PAGE_TITLE_FIELD_KEY)}
                              />
                            </div>
                          )}
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={SEARCH_ICONS_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'search.icons.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                              <div className="brandingColor_left">
                                <div className="d-flex align-items-center">
                                  <div
                                    className="color-button mt-0 me-2"
                                    onClick={() => setDisplayIconPicker(!displayIconPicker)}
                                  >
                                    <div className="color" style={{ background: iconColor }} />
                                  </div>
                                  <span>{iconColor ? `HEX : ${iconColor}` : intl.formatMessage({ id: 'select.color' })}</span>
                                </div>
                                {renderColorPicker(
                                  displayIconPicker,
                                  iconColor,
                                  (value: any) =>
                                    handleColorClick(value, SEARCH_ICONS_COLOR_FIELD_KEY),
                                  () => setDisplayIconPicker(false),
                                )}
                              </div>
                              {iconColor && (
                                <div className="brandingColor_right">
                                  <FontAwesomeIcon
                                    icon={faTimesCircle}
                                    className="save-branding__clear-property"
                                    onClick={() => handleColorRemove(SEARCH_ICONS_COLOR_FIELD_KEY)}
                                  />
                                </div>
                              )}
                            </div>
                          </Form.Item>
                        </Col>

                        {/* <div className='col-md-6 col-6 text-end'>
                            <img
                              id="uploadFavicon-preview"
                              className="border border-white border-3 shadow"
                              src={favicon?.Value}
                              alt="uploadFavicon"
                              style={{ objectFit: 'contain', maxHeight: '85px', height: '100%', width: 'auto' }}
                            />
                          </div> */}

                        <Col xl={6} md={6}>
                          <Form.Item
                            name={BUTTONS_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'buttons.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() => setDisplayPicker(!displayPicker)}
                                >
                                  <div className="color" style={{ background: buttonsColor }} />
                                </div>
                                <span>
                                  {buttonsColor ? `HEX : ${buttonsColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayPicker,
                                buttonsColor,
                                (value: any) => handleColorClick(value, BUTTONS_COLOR_FIELD_KEY),
                                () => setDisplayPicker(false),
                              )}
                            </div>
                            {buttonsColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() => handleColorRemove(BUTTONS_COLOR_FIELD_KEY)}
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>

                        <Col xl={6} md={6}>
                          <Form.Item
                            name={HEADER_BACKGROUND_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'header.background.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() =>
                                    setDisplayHeaderIconPicker(!displayHeaderIconPicker)
                                  }
                                >
                                  <div className="color" style={{ background: headerIconColor }} />
                                </div>
                                <span>
                                  {headerIconColor ? `HEX : ${headerIconColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayHeaderIconPicker,
                                headerIconColor,
                                (value: any) =>
                                  handleColorClick(value, HEADER_BACKGROUND_COLOR_FIELD_KEY),
                                () => setDisplayHeaderIconPicker(false),
                              )}
                            </div>
                            {headerIconColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() =>
                                    handleColorRemove(HEADER_BACKGROUND_COLOR_FIELD_KEY)
                                  }
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={HEADER_FONTS_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'header.font.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() =>
                                    setDisplayHeaderFontPicker(!displayHeaderFontPicker)
                                  }
                                >
                                  <div className="color" style={{ background: headerFontColor }} />
                                </div>
                                <span>
                                  {headerFontColor ? `HEX : ${headerFontColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayHeaderFontPicker,
                                headerFontColor,
                                (value: any) =>
                                  handleColorClick(value, HEADER_FONTS_COLOR_FIELD_KEY),
                                () => setDisplayHeaderFontPicker(false),
                              )}
                            </div>
                            {headerFontColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() => handleColorRemove(HEADER_FONTS_COLOR_FIELD_KEY)}
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={FOOTER_BACKGROUND_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'footer.background.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() =>
                                    setDisplayFooterIconPicker(!displayFooterIconPicker)
                                  }
                                >
                                  <div className="color" style={{ background: footerIconColor }} />
                                </div>
                                <span>
                                  {footerIconColor ? `HEX : ${footerIconColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayFooterIconPicker,
                                footerIconColor,
                                (value: any) =>
                                  handleColorClick(value, FOOTER_BACKGROUND_COLOR_FIELD_KEY),
                                () => setDisplayFooterIconPicker(false),
                              )}
                            </div>
                            {footerIconColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() =>
                                    handleColorRemove(FOOTER_BACKGROUND_COLOR_FIELD_KEY)
                                  }
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={FOOTER_FONTS_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'footer.font.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() =>
                                    setDisplayFooterFontPicker(!displayFooterFontPicker)
                                  }
                                >
                                  <div className="color" style={{ background: footerFontColor }} />
                                </div>
                                <span>
                                  {footerFontColor ? `HEX : ${footerFontColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayFooterFontPicker,
                                footerFontColor,
                                (value: any) =>
                                  handleColorClick(value, FOOTER_FONTS_COLOR_FIELD_KEY),
                                () => setDisplayFooterFontPicker(false),
                              )}
                            </div>
                            {footerFontColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() => handleColorRemove(FOOTER_FONTS_COLOR_FIELD_KEY)}
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>
                        <Col xl={6} md={6}>
                          <Form.Item
                            name={BACKGROUND_COLOR_FIELD_KEY}
                            label={intl.formatMessage({ id: 'theme.color' })}
                            rules={[{ required: false }]}
                          >
                            <div className="d-flex align-items-center justify-content-between brandingColor w-100">
                            <div className="brandingColor_left">
                              <div className="d-flex align-items-center">
                                <div
                                  className="color-button mt-0 me-2"
                                  onClick={() =>
                                    setDisplayBackgroundPicker(!displayBackgroundPicker)
                                  }
                                >
                                  <div className="color" style={{ background: backgroundColor }} />
                                </div>
                                <span>
                                  {backgroundColor ? `HEX : ${backgroundColor}` : intl.formatMessage({ id: 'select.color' })}
                                </span>
                              </div>
                              {renderColorPicker(
                                displayBackgroundPicker,
                                backgroundColor,
                                (value: any) => handleColorClick(value, BACKGROUND_COLOR_FIELD_KEY),
                                () => setDisplayBackgroundPicker(false),
                              )}
                            </div>
                            {backgroundColor && (
                              <div className="brandingColor_right">
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="save-branding__clear-property"
                                  onClick={() => handleColorRemove(BACKGROUND_COLOR_FIELD_KEY)}
                                />
                              </div>
                            )}
                          </div>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <div className="d-flex justify-content-end p-3">
                      <BlueButton
                        block
                        size="large"
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary commonBlueBtn"
                        disabled={loading}
                      >
                        <FormattedMessage id="save.changes" />
                      </BlueButton>
                    </div>
                  </Form>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    accountSettingStore: state.accountSettingStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  handlePreferences,
};

const CompanyBranding = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CompanyBrandingComponent));
export default CompanyBranding;
